import photos from "./photos";

export const slides = photos.map(({ src, key, width, height, images }) => ({
  src,
  key,
  width,
  height,
  srcSet: images?.map((image) => ({
    src: image.src,
    width: image.width,
    height: image.height,
  })),
}));

export const advancedSlides = [
  {
    type: "video",
    title: "Big Buck Bunny",
    description:
      "The Peach Open Movie Project\n\nBlender Institute, Netherlands",
    width: 1280,
    height: 720,
    poster:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/images/BigBuckBunny.jpg",
    sources: [
      {
        src: "https://res.cloudinary.com/dcbw508s1/video/upload/v1669224991/samples/cld-sample-video.mp4",
        type: "video/mp4",
      },
    ],
  },
];

export default slides;
